import { useContext, useState } from "react"
import getServices from "../services/getServices"
import deleteService from "../services/deleteService"
import { AuthContext } from "../contexts/auth"
import toast from "react-hot-toast"

const useTemplateState = () => {

    const { signOut } = useContext(AuthContext)
    const [openDialog, setOpenDialog] = useState(false)

    const [templateDeletar, setTemplateDeletar] = useState(false)
    const [pesquisa, setPesquisa] = useState('')
    const [template, setTemplate] = useState([])
    const [submit, setSubmit] = useState(false)
    
    const [ openPermissaoDialog, setOpenPermissaoDialog ] = useState(false)

    //Campos para a paginação
    const [nexPage, setNextPage] = useState(null)
    const [previusPage, setPreviusPage] = useState(null)
    const [totalCount, setTotalCount] = useState(0);
    const [page, setPage] = useState(0);

    const _getTemplate = async (pageToFetch = 1)=>{
        if (submit){
            return;
        }
        setSubmit(true)
        let url = `admin/templateformulario/?page=${pageToFetch}`;
        if (pesquisa !== '') url += `&pesquisa=${pesquisa}`;
        let result = await getServices(url)
        if (result.type === 'success'){
            console.log(result.data.results)
            setTemplate(result.data.results.map(item=>{return {id:item.id, 
                                                        name: item.tipotarefa?.nome, 
                                                        tem_formulario: item.tipotarefa?.tem_formulario, 
                                                        ativo: item.tipotarefa?.ativo,                                                         
                                                        editavel: item.tipotarefa?.editavel, 
                                                        data_criacao: item?.data_criacao, 
                                                        tipo_id: item?.tipotarefa?.id,
                                                        numero_secoes : item?.numero_secoes} }))
           setNextPage(result.data.next)
           setPreviusPage(result.data.previous)
           setTotalCount(result.data.count);                     
        }
        else if (result.data?.code === 'token_not_valid'){
            signOut()
        }
        setSubmit(false)
    }

    const _deleteTemplate = async ()=>{
        if (submit){
            return;
        }
        
        setOpenDialog(false)
        setSubmit(true)
        let result = await deleteService(`admin/templateformulario/${templateDeletar.id}/`)
        if (result.type === 'success'){
            
            toast.success(result.data.detail)
            _getTemplate()
        }
        else if (result.type === 'error'){
            toast.error(result.data.detail.status)
        }
        else if (result.data?.code === 'token_not_valid'){
            signOut()
        }

        setSubmit(false)
    } 

    return {
        
        template: {value: template, set:_getTemplate},
        pesquisa: {value: pesquisa, set:setPesquisa},
        openDialog: {value: openDialog, set:setOpenDialog},
        deletar: {value: ()=>{console.log('não implementado')}, set: _deleteTemplate},
        itemDelete:{value:templateDeletar, set:setTemplateDeletar},  
        pagination: {
            total: totalCount,
            page: page,
            setPage: setPage
        },
        submit: {value: submit, set: _getTemplate},
        openPermissaoDialog: {value: openPermissaoDialog, set: setOpenPermissaoDialog},
    }
}

export default useTemplateState